import { createFileRoute, stripSearchParams } from '@tanstack/react-router'
import { fallback, zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'

import { listTaxonomiesOptions } from '@/api/codegen/@tanstack/react-query.gen'
import { TAXONOMIES_DEFAULT_SEARCH } from '@/api/domain/taxonomy/taxonomy.constants'
import { TaxonomyPage } from '@/pages/taxonomy/Taxonomy.page'

const SEARCH_SCHEMA = z.object({
  name: fallback(z.string(), TAXONOMIES_DEFAULT_SEARCH.name).default(
    TAXONOMIES_DEFAULT_SEARCH.name,
  ),
  sortBy: fallback(z.string(), TAXONOMIES_DEFAULT_SEARCH.sortBy).default(
    TAXONOMIES_DEFAULT_SEARCH.sortBy,
  ),
  createdAt: fallback(
    z.string().nullable(),
    TAXONOMIES_DEFAULT_SEARCH.createdAt,
  ).default(TAXONOMIES_DEFAULT_SEARCH.createdAt),
})

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/taxonomies/',
)({
  component: TaxonomyPage,
  validateSearch: zodValidator(SEARCH_SCHEMA),
  loader: ({ context: { queryClient }, params: { spaceId } }) => {
    queryClient.ensureQueryData(
      listTaxonomiesOptions({
        path: {
          spaceID: spaceId,
        },
      }),
    )
  },
  search: {
    middlewares: [stripSearchParams(TAXONOMIES_DEFAULT_SEARCH)],
  },
})
